(function () {
  "use strict";

  if (window.__SOWN_TLL_ARRIVAL_LOADED__) return;
  window.__SOWN_TLL_ARRIVAL_LOADED__ = true;

  var destinationId = "AW-18022334954";
  var conversionLabel = "TxVrCL_S1fMcEOqD3JFD";
  var sentKey = "sown_tll_successful_arrival_v1";
  var maxReadinessRetries = 10;
  var readinessRetryDelayMs = 200;
  var sentInDocument = false;
  var retryCount = 0;
  var retryTimer = null;

  function hasMarketingConsentApi() {
    try {
      return Boolean(
        window.Shopify &&
          window.Shopify.customerPrivacy &&
          typeof window.Shopify.customerPrivacy.marketingAllowed === "function"
      );
    } catch (error) {
      return false;
    }
  }

  function marketingConsentGranted() {
    try {
      return hasMarketingConsentApi() && Boolean(window.Shopify.customerPrivacy.marketingAllowed());
    } catch (error) {
      return false;
    }
  }

  function alreadySentThisTabSession() {
    try {
      return window.sessionStorage.getItem(sentKey) === "1";
    } catch (error) {
      // Storage denial cannot be treated as a successful send. sentInDocument
      // still prevents duplicates while this document is open.
      return false;
    }
  }

  function markSentThisTabSession() {
    try {
      window.sessionStorage.setItem(sentKey, "1");
    } catch (error) {}
  }

  function clearReadinessRetry() {
    if (retryTimer !== null && typeof window.clearTimeout === "function") window.clearTimeout(retryTimer);
    retryTimer = null;
  }

  function scheduleReadinessRetry() {
    if (sentInDocument || retryTimer !== null || retryCount >= maxReadinessRetries || typeof window.setTimeout !== "function") return;
    retryCount += 1;
    retryTimer = window.setTimeout(function () {
      retryTimer = null;
      trackSuccessfulArrival();
    }, readinessRetryDelayMs);
  }

  function trackSuccessfulArrival() {
    if (sentInDocument || alreadySentThisTabSession()) {
      sentInDocument = true;
      clearReadinessRetry();
      return;
    }

    // Fail closed until Shopify's privacy API is available and grants marketing consent.
    if (!hasMarketingConsentApi()) {
      scheduleReadinessRetry();
      return;
    }
    if (!marketingConsentGranted()) return;

    // Do not load or replace Google tags. Wait briefly for the existing top-window tag.
    if (typeof window.gtag !== "function") {
      scheduleReadinessRetry();
      return;
    }

    try {
      // This target is owned by The Lash List Google Ads account. No page view is sent.
      window.gtag("config", destinationId, { send_page_view: false });
      window.gtag("event", "conversion", {
        send_to: destinationId + "/" + conversionLabel,
        transport_type: "beacon"
      });
      sentInDocument = true;
      markSentThisTabSession();
      clearReadinessRetry();
    } catch (error) {
      scheduleReadinessRetry();
    }
  }

  // Shopify emits this document event when the visitor's consent is collected or changed.
  document.addEventListener("visitorConsentCollected", trackSuccessfulArrival);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", trackSuccessfulArrival, { once: true });
  } else {
    trackSuccessfulArrival();
  }
})();
